import { render } from "./App.vue?vue&type=template&id=d9e7da1e"
const script = {}

import "./App.vue?vue&type=style&index=0&id=d9e7da1e&lang=css"
script.render = render

export default script